
import React, { useEffect, useState, useRef } from 'react'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import ExpensesReview from "./expenses-review"
import { Carousel } from 'primereact/carousel';
import { Util, expenseApi } from '../../services';
import { Menu } from 'primereact/menu';
import { toast } from "react-toastify";
import properties from '../../config/environmentProperties';
import { Dialog } from "primereact/dialog";
import RejectExpensePopup from "./expense-reject-popup";
import ApproveExpensePopup from "./expense-approve-popup";
import { Calendar } from 'primereact/calendar';
import { Timeline } from 'primereact/timeline';
import { DescLength } from '../../common/util/constants';

const ExpenseCategoryManager = (userData) => {
    const [viewEmpExpenses, setViewEmpExpenses] = useState(false);
    const [clickedViewUser, setClickedViewUser] = useState([]);
    const [viewEmpList, setViewEmpList] = useState([true]);
    const [expenseEmployeeList, setExpenseEmployeeList] = useState([]);
    const [selectedDraftExpense, setSelectedDraftExpense] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [rejectRowData, setRejectRowData] = useState({});
    const [rejectDialog, setRejectDialog] = useState(false);
    const [approveRowData, setApproveRowData] = useState({});
    const [approveDialog, setApproveDialog] = useState(false);
    const [currentRowData, setCurrentRowData] = useState(null);
    const [visible, setVisible] = useState(false);
    const docPath = properties.currentEnvironment.docPath + 'expense-documents/';
    const menu = useRef(null);
    const [selectedApprovedData, setSelectedApprovedData] = useState([])
    const [selectAll, setSelectAll] = useState(true)
    const [selectedDateRange, setSelectedDateRange] = useState(null);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [timeline, setTimeline] = useState(false);
    const [expenseActivityData, setExpenseActivityData] = useState([]);
    const [currentRow, setCurrentRow] = useState({});
    const [clickedExpenseCategory, setClickedExpenseCategory] = useState('');

    useEffect(() => {
        getAllExpenseCategoryByManager();
    }, []);

    const getAllExpenseCategoryByManager = () => {
        let param = {}
        expenseApi.getAllCategoryByManager(param).then((resp) => {
            try {
                setExpenseEmployeeList(resp.data.data);
            } catch (error) {
                // Error handle
            }
        });
    };

    const changeOnCustom = (e) => {
        setSelectedDateRange(e.value)
        setSelectedDraftExpense([])
        setSaveDisabled(true)
        var filteredArray = e.value.filter(function (value) {
            return value !== null;
        });
        if (filteredArray?.length == 2) {
            let param = {
                fromDate: filteredArray[0],
                toDate: filteredArray[1],
            }
            setStartDate(param.fromDate);
            setEndDate(param.toDate);
            expenseApi.getAllCategoryByManager(param).then((resp) => {
                try {
                    setExpenseEmployeeList(resp.data.data);
                } catch (error) {
                    // Error handle
                }
            });
            if (e.value[1]) {
                document.getElementsByClassName("p-datepicker")[0].style.display = "none";
            }
        }
    }

    const calendarSection = () => {
        return (
            <div className="field ">
                <div>
                    <label htmlFor="range"></label>{" "}
                    <Calendar
                        id="range"
                        value={selectedDateRange}
                        onChange={(e) => changeOnCustom(e)}
                        selectionMode="range"
                        readOnlyInput
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        showIcon
                        placeholder="Select Period"
                    />
                </div>
            </div>
        );
    };

    let events = [];
    expenseActivityData.map((e) => {
        return Util.expenseActivityData(e, events, clickedExpenseCategory)
    })

    const customizedMarker = (item) => {
        return (
            <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item.color }}>
                <i className={item.icon}></i>
            </span>
        );
    };

    const customizedContent = (item) => {
        return Util.TimelineView(item, clickedExpenseCategory)
    };

    const viewClaimTimeline = (currentRow) => {
        setClickedExpenseCategory(currentRow.category);
        getExpenseActivitiesByClaim(currentRow.claimId)
        setTimeline(true);
    }

    const getExpenseActivitiesByClaim = (claimId) => {
        expenseApi.getClaimActivities(claimId).then((resp) => {
            setExpenseActivityData(resp.data.data)
        });
    }

    const myExpenseTimeline = () => {
        return (
            <>
                <Dialog header="Expense Claim TimeLine" maximizable visible={timeline} onHide={() => setTimeline(false)} style={{ overflow: 'hidden' }}>
                    <div className="flex-column" style={{ width: 500, overflow: 'hidden' }}>
                        <Timeline value={events} className="customized-timeline" marker={customizedMarker} content={customizedContent} />
                    </div>
                </Dialog>
            </>
        );
    };

    const reviewActionBodyTemplate = (rowData) => {
        const items = [
            { label: "VIEW TIMELINE", icon: "pi pi-eye", command: (e) => { viewClaimTimeline(currentRow) } },
            currentRow.status === 2 && { label: "APPROVE", icon: "pi pi-check", command: () => { setApproveDialog(true) } },
            currentRow.status === 2 && { label: "REJECT", icon: "pi pi-times", command: () => { setRejectDialog(true) } },
        ].filter(Boolean);

        const showMenu = (event) => {
            menu.current.toggle(event);
        };

        return (
            <>
                <Menu style={{ width: "15rem" }} model={items} popup ref={menu} />
                <Button
                    className="p-button-rounded p-button-text"
                    icon="pi pi-ellipsis-v"
                    onClick={(e) => {
                        setSelectAll(false)
                        setSelectedApprovedData(rowData);
                        setCurrentRow(rowData);
                        showMenu(e)
                    }}
                />
            </>
        );
    };

    const selectedCategoryExpense = (e) => {
        if (e.value.length > 0) {
            setSaveDisabled(false);
        } else {
            setSaveDisabled(true);
        }
        setSelectedDraftExpense(e.value);

        const statusBased = e.value.some(row => row.status !== 2);
        if (statusBased) {
            setSaveDisabled(true)
            toast.warn("cannot update this record.");
        }
        setSelectedDraftExpense(e.value);
    }

    const approveExpenseDialog = () => {
        return (
            <Dialog className="pop-up-dialog-recall" header="Approve Expense" visible={approveDialog} style={{ width: '380px' }} onHide={() => setApproveDialog(false)}>
                <ApproveExpensePopup
                    updateRejectRow={(data) => approveTeamExpenseData(data)}
                    rejectRow={approveRowData}
                    onClose={(e) => {
                        setApproveDialog(false);
                    }}
                />
            </Dialog>
        );
    };

    const approveTeamExpenseData = (data) => {
        let claimIds;
        if (!selectAll) {
            claimIds = [selectedApprovedData.claimId];
        }
        else {
            claimIds = selectedDraftExpense?.map((item) => item.claimId);
        }
        const param = {
            status: 4,
            claimId: claimIds,
            reason: data.reason,
        };
        try {
            expenseApi.updateDraftExpense(param).then(
                (resp) => {
                    if (resp.data.success === false) {
                        toast.error(resp.data.error);
                        return;
                    }
                    setSaveDisabled(true);
                    toast.success("Expense Record has been Approved & shared for Further Processing...");
                    setSelectedDraftExpense([])
                    setSelectedApprovedData([])
                    setSelectAll(true)
                    getAllExpenseCategoryByManager();
                    setSelectedDateRange(null)
                },
                (err) => {
                    toast.error("There was some error while updating Expense Data...");
                }
            );
        } catch (error) {
            toast.error("There was some error while updating Expense Data...");
        }
    };

    const rejectTeamExpenseData = (data) => {
        let claimIds;
        if (!selectAll) {
            claimIds = [selectedApprovedData.claimId];
        } else {
            claimIds = selectedDraftExpense?.map((item) => item.claimId);
        }
        const param = {
            status: 5,
            claimId: claimIds,
            reason: data.reason,
        };
        try {
            expenseApi.updateDraftExpense(param).then(
                (resp) => {
                    if (resp.data.success === false) {
                        toast.error(resp.data.error);
                        return;
                    }
                    setSaveDisabled(true);
                    toast.success("Expense Record has been Rejected...");
                    setSelectedDraftExpense([])
                    setSelectedApprovedData([])
                    setSelectAll(true)
                    getAllExpenseCategoryByManager();
                    setSelectedDateRange(null)
                },
                (err) => {
                    toast.error("There was some error while updating Expense Data...");
                }
            );
        } catch (error) {
            toast.error("There was some error while updating Expense Data...");
        }
    };

    const RejectExpenseDialog = () => {
        return (
            <Dialog className="pop-up-dialog-recall" header="Reject Expense" visible={rejectDialog} style={{ width: '380px' }} onHide={() => setRejectDialog(false)}>
                <RejectExpensePopup
                    updateRejectRow={(data) => rejectTeamExpenseData(data)}
                    rejectRow={rejectRowData}
                    onClose={(e) => {
                        setRejectDialog(false);
                    }}
                />
            </Dialog>
        );
    };
    const statusBodyTemplate = (data) => {
        return (
            <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>
                {Util.fetchStatus(data.status, data.category)}
            </span>
        );
    };

    const viewDoc = (rowData) => {
        return (
            <>
                <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary ml-2" aria-label="View" tooltip="View Details" tooltipOptions={{ position: "top" }} onClick={() => { setCurrentRowData(rowData); setVisible(true) }} />
            </>
        );
    };

    const renderCarouselContent = (rowData) => {
        return (
            <Carousel
                value={rowData?.docs}
                itemTemplate={yourCarouselItemTemplate}
                numVisible={1}
                numScroll={1}
                circular
            />
        );
    };

    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };

    const carouselPopup = () => {
        return (
            <Dialog header={'Documents'} visible={visible} modal style={{ width: '1200px', height: '900px' }} onHide={() => setVisible(false)}>
                {renderCarouselContent(currentRowData)}
            </Dialog>
        )
    }

    const wrapDescription = (rowData) => {
        const description = rowData.description;
        return (
            <div title={description}>
                {description.length > DescLength.DESCRIPTION ? `${description.substring(0, DescLength.DESCRIPTION)}....` : description}
            </div>
        );
    };

    return (
        <div className="tabview-demo">
            {viewEmpList && (
                <Panel>
                    <div className="formgrid grid">
                        <div className="field col-8" >
                            <Button label="Approve All" severity="success" icon="pi pi-check" className='mr-2 mt-2' onClick={() => { setApproveDialog(true) }} disabled={saveDisabled} />
                            <Button label="Reject All" severity="danger" icon="pi pi-times"  className=' mt-2' onClick={() => setRejectDialog(true)} disabled={saveDisabled} />
                        </div>
                        <div className="field col-4 text-right" >
                            {calendarSection()}
                        </div>
                    </div>
                    <hr />
                    <DataTable
                        paginator
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        Key="id"
                        resizableColumns
                        value={expenseEmployeeList}
                        columnResizeMode="fit"
                        scrollable="horizontal"
                        stripedRows
                        selectionMode="checkbox"
                        selection={selectedDraftExpense}
                        onSelectionChange={(e) => {
                            selectedCategoryExpense(e)
                            const disableSelection = e.value.some(row => row.status !== 2);
                            if (!disableSelection) {
                                setSelectedDraftExpense(e.value);
                            } else {
                                setSelectedDraftExpense(e.value);
                            }
                        }}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: "8rem" }} exportable={false}></Column>
                        <Column field="claimId" header="Claim ID" style={{ minWidth: '1rem' }} />
                        <Column field="ecn" header="ECN" style={{ minWidth: '1rem' }} />
                        <Column field="firstName" header="Name" body={Util.fullNameBody} style={{ minWidth: '1rem' }} />
                        <Column field="claimAmount" header="Amount" style={{ minWidth: '1rem' }} body={(rowData) => Util.renderClaimAmount(rowData)} />
                        <Column field="category" header="Category" style={{ minWidth: '1rem' }} />
                        <Column field="businessUnits" header="BusinessUnit" style={{ minWidth: '1rem' }} />
                        <Column header="Project" body={Util.userProjects} style={{ minWidth: '1rem' }} />
                        <Column field="description" header="Description" style={{ minWidth: '2rem' }} body={wrapDescription} />
                        <Column field="status" header="Status" style={{ minWidth: '1rem' }} body={statusBodyTemplate} />
                        <Column header="Document" style={{ minWidth: '1rem' }} body={viewDoc} />
                        <Column header="Action" style={{ minWidth: '1rem' }} body={reviewActionBodyTemplate} />
                    </DataTable>
                </Panel>
            )}
            {viewEmpExpenses && (
                <ExpensesReview userData={clickedViewUser} />
            )}
            {RejectExpenseDialog()}
            {approveExpenseDialog()}
            {carouselPopup()}
            {myExpenseTimeline()}
        </div>
    )
}
export default ExpenseCategoryManager;